package floris.graphics.landing.pages

import floris.graphics.core.utils.MVI
import floris.graphics.repo.CategoryRepo
import floris.graphics.repo.ProjectRepo
import floris.graphics.repo.TechstackRepo
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.async
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asSharedFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch
import kotlinx.coroutines.withContext

class HomeViewModel(
    private val queryCategoryId: String? = null,
    private val projectRepo: ProjectRepo = ProjectRepo,
    private val techstackRepo: TechstackRepo = TechstackRepo,
    private val categoryRepo: CategoryRepo = CategoryRepo,
    private val coroutineScope: CoroutineScope = CoroutineScope(SupervisorJob() + Dispatchers.Default)
) : MVI<HomeContract.State, HomeContract.Intent, HomeContract.Effect> {

    private val _state = MutableStateFlow(HomeContract.State(queryCategoryId))
    override val state = _state.asStateFlow()

    private val _effect = MutableSharedFlow<HomeContract.Effect>()
    override val effect = _effect.asSharedFlow()

    init {
        sendIntent(HomeContract.Intent.LoadInitialData)
    }

    override fun sendIntent(intent: HomeContract.Intent) = coroutineScope.launch {
        when (intent) {
            is HomeContract.Intent.LoadInitialData -> loadInitialData()
            is HomeContract.Intent.Navigate -> emitEffect(HomeContract.Effect.Navigate(intent.route))
            is HomeContract.Intent.SelectCategory -> {
                val projects = projectRepo.getProjects(categoryId = intent.categoryId)
                updateState { it.copy(queryCategoryId = intent.categoryId, projects = projects) }
            }
        }
    }

    private suspend fun loadInitialData() = withContext(Dispatchers.Default) {
        val categoriesDeferred = async { categoryRepo.getCategories() }
        val techstacksDeferred = async { techstackRepo.getTechstacks() }
        val projectsDeferred = async { projectRepo.getProjects(categoryId = queryCategoryId) }

        val categories = categoriesDeferred.await()
        val techstacks = techstacksDeferred.await()
        val projects = projectsDeferred.await()

        updateState {
            it.copy(
                categories = categories,
                techStacks = techstacks,
                projects = projects
            )
        }
    }

    override fun emitEffect(effect: HomeContract.Effect) = coroutineScope.launch {
        _effect.emit(effect)
    }

    override fun updateState(block: (HomeContract.State) -> HomeContract.State) {
        _state.update(block)
    }
}
